import type { NextPageContext } from 'next'

import { fetchMenu } from 'utils/api/loadMenu/loadMenu'
import type { LanguageCode } from 'utils/utils'
import { safeStringify, getRandomUUID } from 'utils/utils'
import { CACHE_POLICY } from '../../../utils/constants'
import MenuPage from 'static/pages/Menu'

const Menu = (props: { Application: any; Infra: any; data: any; lang: LanguageCode }) => <MenuPage {...props} />

export async function getServerSideProps(context: NextPageContext & { req: { extra: { appParams: any; nextJsError: string } } }) {
	// Static menu page data fetching
	if (context.req && !context.req.extra?.nextJsError) {
		try {
			const lang = context.query.lang as string
			const appParams = context.req.extra?.appParams
			const data = await fetchMenu(appParams.c, appParams.c)

			if (!data) {
				throw new Error('Failed to fetch menu data for /menu page', appParams.c)
			}

			if (context.res) {
				context.res.setHeader(
					'Cache-Control',
					`public, s-maxage=${CACHE_POLICY.DEFAULT.MAX_AGE}, stale-while-revalidate=${CACHE_POLICY.DEFAULT.REVALIDATED_AGE}`
				)
			}

			return {
				props: {
					data,
					lang,
					traceId: getRandomUUID(),
				},
			}
		} catch (e: any) {
			if (context.res) {
				context.res.statusCode = 500
				context.res.setHeader('Cache-Control', 'no-store')
			}

			return { props: { data: null, traceId: getRandomUUID(), error: safeStringify(e) } }
		}
	}
	if (context.res) {
		context.res.statusCode = 500
		context.res.setHeader('Cache-Control', 'no-store')
	}

	return { props: { data: null, traceId: getRandomUUID() } }
}

export default Menu
